import { Show } from 'solid-js';
import { Forms } from '../forms/forms';
import { FieldType, FormStep } from '../forms/forms.types';

type FormWpData = {
    blockName: string;
    fields?: FieldType[];
    steps?: FormStep[];
    hideStepNames?: boolean;
};

type ParsedFormData = {
    steps: FormStep[];
    hideStepNames?: boolean;
};

export const FormSelector = (props: any) => {
    // We keep backwards compability for when we didnt put the data within a 'form' property in our php-structure
    // IF we are sure that all form-selector blocks has been re-saved, we can remove this.
    const isNewFormat = props?.form?.blocks?.length;

    const data = () => {
        if (isNewFormat) {
            return stepify(props?.form?.blocks?.[ 0 ]);
        } else {
            return stepify(props?.blocks?.[ 0 ]);
        }
    };

    const stepify = (data: FormWpData) => {
        let parsedData: ParsedFormData;

        if (data.steps && !data.fields) {
            // Filter out 'acceptPolicy' fields from each step - this is for safety, 
            // as this field _should_ already be omitted from WP data, but we want to be sure.
            const stepsWithoutAcceptPolicy = data.steps.map((step) => ({
                ...step,
                fields: step.fields.filter((field) => field.slug !== 'acceptPolicy'),
            }));

            parsedData = {
                steps: stepsWithoutAcceptPolicy,
            };
        } else if (!data.steps && data.fields) {
            // If no 'steps' field, we instead will have 'fields' field (old format)
            const fieldsWithoutAcceptPolicy = data.fields.filter((field) => field.slug !== 'acceptPolicy');

            const stepifiedFields: FormStep = {
                stepName: '',
                fields: fieldsWithoutAcceptPolicy,
            };

            parsedData = {
                steps: [ stepifiedFields ]
            };
        } else {
            // Shouldn't ever get here, but needed to make TS happy
            parsedData = {
                steps: [] as FormStep[]
            };
        }        

        // Remove all steps that have no fields
        parsedData.steps = parsedData.steps.filter((step) => step.fields && step.fields.length > 0);
        parsedData.hideStepNames = data?.hideStepNames;

        return parsedData;
    };

    return (
        <Show when={isNewFormat || props?.blocks?.length} fallback={<div />}>
            <Forms
                {...data()}
                formCampaignId={isNewFormat ? props?.form?.formCampaignId : undefined}
            />
        </Show>
    );
};
